import React  from 'react';
  
//../../shared/constants/AppConst
export const settingsListConfig = [
  {
    auth: ['user'],
    routes: [
      {
        path: '/settings',
        component: React.lazy(() => import('./SettingsTabs')),
      },
    ],
  },
  
];
